import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  BlanketInsurance,
  BlanketInsuranceSearchQuery,
  PatchBlanketInsurance,
  PostBlanketInsurance,
} from '@models/next/BlanketInsurance';
import { z } from 'zod';

export const blanketInsuranceApis = createApiHooks('/blanket-insurance', [
  {
    path: '/',
    method: 'get',
    parameters: schemaToQueryParameters(BlanketInsuranceSearchQuery),
    response: BlanketInsurance.array(),
  },
  {
    path: '/:id',
    method: 'get',
    response: BlanketInsurance,
  },
  {
    path: '/:id',
    method: 'delete',
    response: z.unknown(),
  },
  {
    path: '/',
    method: 'post',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostBlanketInsurance,
      },
    ],
    response: BlanketInsurance,
  },
  {
    path: '/:id',
    method: 'patch',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PatchBlanketInsurance,
      },
    ],
    response: BlanketInsurance,
  },
]);

export const dashboardBlanketInsuranceApis = createApiHooks('/dashboard/blanket-insurance', [
  {
    path: '/',
    method: 'get',
    parameters: schemaToQueryParameters(BlanketInsuranceSearchQuery),
    response: BlanketInsurance.array(),
  },
  {
    path: '/:id',
    method: 'get',
    response: BlanketInsurance,
  },
]);
